import { Observable } from 'rxjs';

export const promiseWrapper = <T>(observable: Observable<T>) => {
  return new Promise<T>((resolve, reject) => observable.subscribe((v: T) => resolve(v), (e: any) => reject(e)));
};
